module.exports = __webpack_public_path__ + "static/media/grid-selected.dc62a9f9.svg";